export default __webpack_public_path__ + "static/media/cancer_logo.321f9597.png";